import { render, staticRenderFns } from "./tab-pane-temp.vue?vue&type=template&id=2d93f0a8&scoped=true&"
import script from "./tab-pane-temp.vue?vue&type=script&lang=js&"
export * from "./tab-pane-temp.vue?vue&type=script&lang=js&"
import style0 from "./tab-pane-temp.vue?vue&type=style&index=0&id=2d93f0a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d93f0a8",
  null
  
)

export default component.exports